import {
  BROKER_CONCENTRATION_RELOADED_TIME,
  BROKER_CONCENTRATION_RESULT_BY,
  BROKER_CONCENTRATION_SET_SECTOR,
  BROKER_CONCENTRATION_TABLE_DATA,
  IS_LOADING,
} from '../../redux/BrokerConcentration/ActionTypes';
import { message } from 'antd';
import axiosOrder from '../../axios';

const reducer = (state = {
  viewBy: 1, tableData: [], sector: 'All', loading: false, reloadedTime: '',
},
action: { type: string; data: string; }) => {
  switch (action.type) {
  case BROKER_CONCENTRATION_RESULT_BY:
    return {
      ...state,
      loading: false,
      viewBy: action.data,
    }
  case BROKER_CONCENTRATION_RELOADED_TIME:
    return {
      ...state,
      reloadedTime: action.data,
    }
  case BROKER_CONCENTRATION_TABLE_DATA:
    return {
      ...state,
      tableData: action.data,
    }
  case BROKER_CONCENTRATION_SET_SECTOR:
    return {
      ...state,
      loading: false,
      sector: action.data,
    }
  case IS_LOADING:
    return {
      ...state,
      loading: action.data,
    }
  default:
    return state;
  }
}

const Loading = (loading: boolean) => ({ type: IS_LOADING, data: loading });
const setBrokerConcentrationData = (response: any) => ({ type: BROKER_CONCENTRATION_TABLE_DATA, data: response });
const setBrokerConcentrationReloadedTime = (data: string) => ({ type: BROKER_CONCENTRATION_RELOADED_TIME, data });

export const loadBrokerConcentration = (sector: string, date: number) => async (dispatch: (data: any) => void) => {
  try {
    dispatch(Loading(true));
    const { data: { data, reloadedTime } } = await axiosOrder.get('/systemx/dalalstreet/brokerConcentration', {
      params: {
        sector,
        date,
      },
    })
    dispatch(setBrokerConcentrationData(data));
    dispatch(setBrokerConcentrationReloadedTime(reloadedTime));
    dispatch(Loading(false));
  } catch (ex) {
    message.error('Cannot load Broker Concentration. Try again');
    dispatch(setBrokerConcentrationData([]));
    dispatch(Loading(false));
  }
}
export default reducer;



// WEBPACK FOOTER //
// ./src/dalalstreet/src/redux/BrokerConcentration/Actions.ts